/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_SUBSCRIPTIONS, GET_SUBSCRIPTIONS } from 'src/actions/subscriptionActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SUBSCRIPTIONS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_SUBSCRIPTIONS: {
      const { subscriptions, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = subscriptions;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default subscriptionReducer;
